import { useEffect, useState, useContext, useRef, useMemo } from 'react';
import {
  getAllModuleTreeReq,
  getSingleExecutionDataReq,
  getSingleExecutionDetailsReq,
  reExecuteSuiteReq,
  terminateExecutionSuiteReq,
  getExecutionTreeExpandAllResultReq,
  getExecutionTreeResultSyncReq,
} from '@api/api_services';
import TableTree from '@pages/common/table_tree/table_tree';
import { SearchOutlined, Sync } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { getFormattedTextStatus, textColor } from '@pages/results/result';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CreateEditSuite from '@pages/execution/suites/create-edit-suit';
import { CommonLoader } from '@src/pages/common/common-loader';
import { ProgressContainerContext } from '@src/common/ProgressContainer';
import { setIDB } from '@src/util/localForage_idb_controller';
import { getStatusTypeForPending } from '@pages/execution/suites/details-child-pages/module-details-page';
import {
  executionDashboardInfo,
  partialResultPageStatuses,
} from '@src/pages/test-development/execution-dashboard/execution-dashboard-util';
import { getTruncatedText } from '@src/util/common_utils';
import TerminateWarningComponent from '@src/pages/test-development/execution-dashboard/modals/terminate-warning-component';
import { CircularProgressWithLabel, useCircularProgress } from '@src/common/CircularProgressContainer';

const ExecutionSpecificPageParallelExecution = ({ MyAlert }) => {
  let machineNameArray = [];
  let selectedMechianObj;
  const selectedExecutionId = window.location.pathname.split('/')[5];
  const { resetProgress, startOrResumeProgress } = useContext(ProgressContainerContext);
  const [executionData, setExecutionData] = useState([]);
  const [allTreeRootData, setAllTreeRootData] = useState({});
  let [isLoading, setIsLoading] = useState(true);
  let [treeData, setTreeData] = useState([]);
  let [suiteDetails, setSuiteDetails] = useState();

  let [rootData, setRootData] = useState([]);
  let [isExpandAll, setIsExpandAll] = useState(false);
  let renderTree;
  const history = useHistory();
  let [resultStatus, setResultStatus] = useState({});
  const [value, setValue] = useState(0);
  const [screenMode, setScreenMode] = useState('moduleSpecificPage');
  const [isSyncDisabled, setIsSyncDisabled] = useState(false);
  const [tabData, setTabData] = useState([]);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [selectedExeObject, setSelectedExeObject] = useState({});
  const execResponseDataRef = useRef(null);
  const [exeResponse, setExeResponse] = useState([]);
  const [tabRunId, setTabRunId] = useState('');
  executionData?.suite?.machines?.selectedMachines?.forEach((macInstances) =>
    macInstances?.machineInstances?.forEach((retMacObj) => {
      machineNameArray.push(retMacObj);
    })
  );
  const { progress, startCircularProgress } = useCircularProgress(`parallel-${selectedExecutionId}`);
  selectedMechianObj = machineNameArray?.[value];
  machineNameArray = executionData?.suite?.machines?.selectedMachines;
  const { hasUserViewAccessInExecution } = useMemo(
    () => ({
      hasUserViewAccessInExecution: window.permission?.isOnlyViewAccess('execution'),
    }),
    []
  );

  useEffect(() => {
    getModuleTree();
  }, []);

  useEffect(() => {
    let timerId = null;
    if (isSyncDisabled) {
      timerId = setTimeout(() => {
        setIsSyncDisabled(false);
      }, process.env.REACT_APP_SUITE_EXECUTION_INTERVAL || 10000);
    }
    return () => clearTimeout(timerId);
  }, [isSyncDisabled]);

  function getExecutionData() {
    getSingleExecutionDataReq(selectedExecutionId)
      .then((results) => {
        const response = results?.data?.responseObject;
        setExecutionData((d) => response);
        if (response?.suite.selectedModulesAndScripts[0]?.children?.length) {
          setSuiteDetails(response.suite);
          let tempArray = response?.suite.selectedModulesAndScripts[0]?.children;
          tempArray.forEach((obj) => {
            if (obj?.checkbox) {
              obj.checkbox = false;
            }
          });
        }
        setTreeData(response?.suite.selectedModulesAndScripts[0]?.children);
      })
      .catch((error) => {
        console.log(error);
      });
    return [];
  }

  function getSingleExecutionData(runId, index) {
    const parallelTabRunId = runId || tabRunId;
    resetProgress();
    startOrResumeProgress({
      stopAt: 90,
      isBulkLoad: true,
    });
    setIsLoading(true);
    getSingleExecutionDataReq(selectedExecutionId)
      .then((results) => {
        const response = results?.data?.responseObject;
        setExecutionData((d) => response);
        if (response) {
          let machineInstaces = [];
          let selectedMacArray = response?.suite?.machines?.selectedMachines;
          if (selectedMacArray) {
            selectedMacArray?.map((macObj) => {
              macObj?.machineInstances.map((macInstances) => {
                for (let tabData = 0; tabData < macInstances?.numberOfRuns; tabData++) {
                  machineInstaces.push(macInstances);
                }
                return null;
              });
              return null;
            });
            setTabData(machineInstaces);
          }
        }
        if (response) {
          let clientExist;
          if (response.suite) setSuiteDetails(response.suite);
          if (response?.executionStatus === 'Completed') {
            if (response?.fancyTreeData) {
              if (response?.fancyTreeData?.responseObject?.executionResponses?.length) {
                if (parallelTabRunId) {
                  clientExist = response?.fancyTreeData?.responseObject?.executionResponses.find(
                    (tempObj) => tempObj.runId === parallelTabRunId
                  );
                }
                if (clientExist) {
                  let tempArray = clientExist?.children[0]?.children;
                  tempArray.forEach((obj) => {
                    if (obj?.checkbox) {
                      obj.checkbox = false;
                    }
                  });
                  setTreeData(tempArray);
                }
                if (clientExist?.children[0]) {
                  setAllTreeRootData(clientExist?.children[0]);
                }
              }
              setTimeout(() => {
                resetProgress();
                setIsLoading(false);
              }, 100);
            } else {
              getExecutionTreeExpandAllResult(selectedExecutionId, false, runId).then(() => {
                resetProgress();
                setIsLoading(false);
              });
            }
          } else if (['Running', 'Terminated'].includes(response?.executionStatus)) {
            getExecutionTreeExpandAllResult(selectedExecutionId, true, runId);
            getExecutionTreeResultSyncReq(selectedExecutionId)
              .then((res) => {
                const resp = res?.data?.responseObject;
                let clientExist;
                if (resp?.executionResponses?.length) {
                  if (index > -1) {
                    clientExist = resp?.executionResponses[index];
                  } else {
                    if (parallelTabRunId) {
                      clientExist = resp?.executionResponses.find((tempObj) => tempObj.runId === parallelTabRunId);
                    } else {
                      clientExist = resp?.executionResponses.find(
                        (tempObj) => tempObj?.clientId === selectedMechianObj?.clientId
                      );
                    }
                  }
                  if (clientExist) {
                    setResultStatus(clientExist?.executionStatusObject);
                  } else {
                    setResultStatus();
                  }
                }
                if (resp) {
                  if (response?.suite.selectedModulesAndScripts[0]?.children) {
                    let tempArray = response?.suite.selectedModulesAndScripts[0]?.children;
                    tempArray.forEach((obj) => {
                      if (obj?.checkbox) {
                        obj.checkbox = false;
                      }
                    });
                    setTreeData(tempArray);
                  }
                  setTimeout(() => {
                    resetProgress();
                    setIsLoading(false);
                  }, 100);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            if (response?.suite.selectedModulesAndScripts[0]?.children) {
              let tempArray = response?.suite.selectedModulesAndScripts[0]?.children;
              tempArray.forEach((obj) => {
                if (obj?.checkbox) {
                  obj.checkbox = false;
                }
              });
              setTreeData(tempArray);
              setTimeout(() => {
                resetProgress();
                setIsLoading(false);
              }, 100);
            }
          }
        }
      })
      .catch((error) => {
        resetProgress();
        setIsLoading(false);
        console.error('GET_SINGLE_EXECUTIONDATA_PAR : ', error);
      });
    return [];
  }

  const onCheckedNodes = (nodes) => {};

  function onNodeSelected() {
    console.log(`clicked`);
  }

  function getExecutionTreeExpandAllResult(selectedExecutionId, updateState, runId) {
    getExecutionTreeExpandAllResultReq(selectedExecutionId)
      .then((res) => {
        const resp = res?.data?.responseObject;
        let clientExist = null;
        let tabId = runId || tabRunId || resp?.executionResponses[0]?.runId;
        setExeResponse(resp?.executionResponses || []);
        setTabRunId(tabId);
        localStorage.setItem('parallel_runId', JSON.stringify(resp?.executionResponses));
        if (resp) {
          execResponseDataRef.current = resp;
          if (resp?.executionResponses?.length) {
            if (tabId) {
              clientExist = resp?.executionResponses.find((tempObj) => tempObj.runId === tabId);
            } else {
              clientExist = resp?.executionResponses.find(
                (tempObj) => tempObj?.clientId === selectedMechianObj?.clientId
              );
            }
            if (clientExist) {
              if (clientExist?.children?.[0].children) {
                let tempArray = clientExist?.children[0].children;
                tempArray.forEach((obj) => {
                  if (obj?.checkbox) {
                    obj.checkbox = false;
                  }
                });
                if (!updateState) {
                  setTreeData(tempArray);
                }
              }
              if (clientExist?.children[0]) {
                setAllTreeRootData(clientExist?.children[0]);
              }
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const onStatusClick = async (nodeObj) => {
    let executionResponses;
    let exec_id;
    let machine;
    let execResponseDataCopy = execResponseDataRef?.current;
    if (execResponseDataCopy?.fancyTreeData?.responseObject) {
      executionResponses = execResponseDataCopy.fancyTreeData.responseObject.executionResponses;
      exec_id = execResponseDataCopy._id;
    } else if (execResponseDataCopy?.executionResponses) {
      executionResponses = execResponseDataCopy.executionResponses;
      exec_id = executionResponses[0].executionId;
    }
    if (executionResponses && suiteDetails) {
      let clientExecutionResponse;
      if (tabRunId) {
        clientExecutionResponse = executionResponses.find((_res) => _res?.runId === tabRunId);
      } else {
        clientExecutionResponse = executionResponses.find((_res) => _res?.clientId === selectedMechianObj?.clientId);
      }
      const _resTreeData = clientExecutionResponse?.children[0];
      const exec_name = suiteDetails.name;
      const multiple = suiteDetails.machines.multiple;
      if (executionResponses.length) {
        let resultObj = { responseObject: { executionResponses: executionResponses } };
        setIDB('execResult', resultObj);
      }
      if (!_resTreeData?.hasOwnProperty('storageDetails')) {
        if (clientExecutionResponse?.storageDetails) {
          _resTreeData['storageDetails'] = clientExecutionResponse?.storageDetails;
        } else if (suiteDetails?.storageDetails) {
          _resTreeData['storageDetails'] = suiteDetails?.storageDetails;
        }
      }
      if (!_resTreeData?.hasOwnProperty('executionId'))
        _resTreeData['executionId'] = clientExecutionResponse?.executionId;
      if (nodeObj.data && nodeObj.data.selectedSystem) machine = nodeObj.data.selectedSystem.machineInfo?.hostName;
      else machine = clientExecutionResponse?.machine;
      if (machine) {
        if (executionResponses) {
          let machine_basic_info = executionResponses.map((data) => ({
            title: data?.machine,
            name: data?.name,
            clientId: data?.clientId,
            executionId: data?.executionId,
            runId: data?.runId,
          }));
          localStorage.setItem('machineInfo', JSON.stringify(machine_basic_info));
        }
        if (_resTreeData) {
          setIDB('tree-data', _resTreeData);
        }
        if (nodeObj.data.folder || nodeObj.isRootNode) {
          if (nodeObj.isRootNode) {
            //if root status clicked
            history.push({
              pathname: `/execution/suite/${exec_name}/execution dashboard/overview/machines/${machine}/Result`,
              search: `?executionId=${exec_id}`,
            });
          } else {
            //if a module status clicked
            const node = nodeObj.node;
            var dict = node.toDict(true, function (dict, node) {
              const data = { ...dict.data };
              delete dict.partsel;
              delete dict.selected;
              delete dict.data;
              Object.assign(dict, data);
            });
            setIDB('sub-tree-data', dict);
            let id = nodeObj.data.id;
            if (!id) id = nodeObj.data._key;
            if (nodeObj.node.data.status !== 'SKIP') {
              if (nodeObj?.node?.data?.status === 'N/A' || nodeObj?.node?.data?.status === 'Aborted') return;
              history.push({
                pathname: `/execution/suite/${exec_name}/execution dashboard/overview/machines/${machine}/Root Module/${nodeObj.node.title}/results`,
                search: `?executionId=${exec_id}&id=${id}&multiple=${multiple}`,
              });
            }
          }
        } else {
          if (nodeObj.node.type === 'Script') {
            setIDB('sub-tree-data', treeData[0]);
            const scriptData = [nodeObj.data];
            const clientId = clientExecutionResponse.clientId;
            setIDB('script-data', scriptData);
            let __status = nodeObj.node.data.status;
            if (!__status && resultStatus) {
              __status = resultStatus?.[nodeObj?.data?._key];
            }
            if (__status !== 'SKIP') {
              if (__status === 'N/A' || __status === 'Aborted') return;
              history.push({
                pathname: `/execution/suite/${exec_name}/execution dashboard/overview/machines/${machine}/Root Module/${nodeObj.node.title}/Result`,
                search: `?id=${nodeObj.node.key}&executionId=${exec_id}&clientId=${clientId}&multiple=${multiple}&runId=${tabRunId}`,
              });
            }
          }
        }
      }
    } else {
      console.error('Please sync the result');
    }
  };

  async function getModuleTree() {
    let getdata;
    let root;
    try {
      getdata = await getAllModuleTreeReq();
      localStorage.setItem('getdata', JSON.stringify(getdata));
      let rootDetails = getdata.data.responseObject.moduleTree[0];

      root = {
        subModuleCount: rootDetails.subModuleCount,
        title: rootDetails.title,
        scriptCount: rootDetails.scriptCount,
        key: rootDetails.key,
        ver: rootDetails.ver,
        modifiedByUname: rootDetails.modifiedByUname,
      };
      setAllTreeRootData({ ...root });
      setRootData(root);
      setIsExpandAll(rootDetails.expanded);
      if (getdata) {
        getExecutionTreeExpandAllResult(selectedExecutionId, true);
        getSingleExecutionData('', 0);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const handleTab = (runId, newValue) => {
    if (runId !== tabRunId) {
      setTabRunId(runId);
      setValue(newValue);
      selectedMechianObj = machineNameArray?.[newValue];
      getSingleExecutionData(runId, newValue);
    }
  };

  const LABELS = {
    EXPAND_ALL: 'Expand All',
    COLLAPSE_ALL: 'Collapse All',
    SHOW_ALL_ELEMENTS: 'Show all scripts',
    HIDE_ALL_ELEMENTS: 'Hide all scripts',
    SHOW_PRE_POST_CONDITION: 'Show Pre/Post Conditions',
    HIDE_PRE_POST_CONDITION: 'Hide Pre/Post Conditions',
  };

  const colDefs = [
    {
      field: 'title',
      title: 'MODULE',
      class: 'title',
      isTitle: true,
      width: `calc(100% - 550px)`,
      folderTitleWidth: `calc(100% - 670px)`,
      render: (nodeObj) => {
        return <></>;
      },
    },

    {
      field: 'scriptType',
      title: 'TYPE',
      class: 'Type truncate',
      width: '120px',
      render: (nodeObj) => {
        return <span className="text-xs table-non-link-color-common">{nodeObj?.data?.scriptType}</span>;
      },
    },
    {
      field: 'status',
      title: 'STATUS',
      class: 'status',
      width: '100px',
      render: (nodeObj) => {
        let _status;
        if (nodeObj?.data?.status && nodeObj?.data?.status !== 'disabled' && nodeObj?.data?.status !== 'enabled')
          _status = nodeObj?.data?.status;
        if (!_status && resultStatus) {
          _status = resultStatus?.[nodeObj?.data?.key];
          if (!_status) _status = resultStatus?.[nodeObj?.data?._key];
        }
        return (
          <>
            {_status ? (
              <span
                className={`${
                  nodeObj?.data?.status === 'N/A' ||
                  (nodeObj?.data?.type === 'Script' && nodeObj?.data?.status === 'Aborted')
                    ? 'cursor-pointer'
                    : 'cursor-pointer'
                }  ${textColor(_status)}`}
                name="status"
                onClick={
                  _status.toLowerCase() !== 'skip' || _status.toLowerCase() !== 'n/a'
                    ? () => {
                        if (!nodeObj.isRootNode) {
                          if (nodeObj?.data.type === 'Script' && nodeObj?.data?.status === 'Aborted') {
                          } else {
                            onStatusClick(nodeObj);
                          }
                        }
                      }
                    : ''
                }
              >
                {getFormattedTextStatus(_status)}
              </span>
            ) : (
              ''
            )}
          </>
        );
      },
    },
    {
      field: 'modifiedByUname',
      title: 'MODIFIED BY',
      class: 'modified-by',
      width: '200px',
      render: (nodeObj) => {
        return (
          <div>
            {!nodeObj.isRootNode && <span className="table-non-link-color-common">{nodeObj.data.modifiedByUname}</span>}
          </div>
        );
      },
    },
  ];

  if (isLoading) {
    renderTree = <CommonLoader />;
  } else if (treeData && treeData.length > 0) {
    renderTree = (
      <TableTree
        executionData={executionData}
        isExecutionTree={true}
        runId={tabRunId}
        data={treeData}
        rootData={allTreeRootData}
        colDefs={colDefs}
        expandAll={isExpandAll}
        hideElements={false}
        hideConditions={true}
        conditions={[
          { key: 'title', value: 'Preconditions' },
          { key: 'title', value: 'Postconditions' },
        ]}
        hideConditionBtn={false}
        labels={LABELS}
        onNodeSelected={onNodeSelected}
        id="execution-specific-page-parallel-execution"
      />
    );
  } else {
    renderTree = (
      <div>
        <div>
          <TableTree
            executionData={executionData}
            data={[]}
            rootData={rootData}
            colDefs={colDefs}
            showCheckbox={false}
            onCheckedNodes={onCheckedNodes}
            expandAll={isExpandAll}
            hideConditions={true}
            conditions={[
              { key: 'title', value: 'Preconditions' },
              { key: 'title', value: 'Postconditions' },
            ]}
            hideConditionBtn={false}
            labels={LABELS}
            onNodeSelected={onNodeSelected}
            id="execution-specific-page-parallel-execution"
          />
        </div>
        <div className="overflow-y-auto h-82">
          <div className=" fontPoppinsRegularMd mt-28 no-steps">
            <div classname="create-set-layout">
              <div className="qucBtn">
                <label className="quick-start-style px-1  ">No Data Available </label>
                <br></br>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function TerminateExecution(id) {
    terminateExecutionSuiteReq(id).then((results) => {
      const { message = '', status = '' } = results?.data;
      if (status === 'SUCCESS') {
        const { name } = executionData || {};
        const execName = getTruncatedText(name, 30);
        MyAlert.success(`${execName} execution terminated successfully`);
        getSingleExecutionData();
      } else {
        if (message.includes('is completed')) {
          MyAlert.info(message);
        } else {
          MyAlert.warning(message);
        }
      }
    });
  }

  function executeFunction(executionData) {
    reExecuteSuiteReq(executionData?._id).then((results) => {
      const response = results?.data?.responseObject;
      if (response) {
        history.push(`/execution/suite/${executionData?.name}/suite-dashboard?suiteId=${executionData?.suiteId}`);
      } else {
        console.error(results?.data?.message);
      }
    });
  }

  function reRunFailed(execution) {
    getSingleExecutionDetailsReq(execution?._id).then((results) => {
      const response = results.data.responseObject;
      if (response) {
        let treeData = response?.executionResponses[0].executionStatusObject;
        let selectedModuleData = execution?.suite?.selectedModulesAndScripts;
        setPreselectedValue(selectedModuleData[0].children, treeData, execution);
      }
    });
  }

  const onStatus = (nodeObj) => {
    const selectedExecutionId = window.location.pathname.split('/')[5];
    if (nodeObj && nodeObj.suite.name && nodeObj._id) {
      history.push(
        `/execution/suite/${nodeObj.suite.name}/execution dashboard/overview/machines/Result?executionId=${selectedExecutionId}&multiple=true`
      );
    }
  };

  function setPreselectedValue(selectedModuleData, treeData, selectedObj) {
    if (selectedModuleData.length) {
      selectedModuleData.map((treeObj, index) => {
        if (treeObj.folder) {
          if (treeData[treeObj.key] === 'FAIL') {
            let scriptArray = filterFailedScripts(treeObj?.children, treeData, selectedObj);
            treeObj.children = scriptArray;
          } else {
            selectedModuleData.splice(index, 1);
            if (selectedObj?.suite?.selectedModulesStatus) {
              delete selectedObj?.suite?.selectedModulesStatus[treeObj.key];
            }
          }
        }
        return null;
      });

      selectedObj.suite.selectedModulesAndScripts[0].children = selectedModuleData;
      localStorage.setItem('selectedSuite', JSON.stringify(selectedObj?.suite));
      localStorage.setItem('rerun', JSON.stringify(true));
      setScreenMode('rerunFailed');
      history.push(
        `/execution/suite/${selectedObj?.name}/suite-dashboard/${selectedObj?._id}?executionId=${selectedObj?._id}&suiteId=${selectedObj?.suiteId}&&detailsPage=specificExePageParallel`
      );
    }
  }

  function filterFailedScripts(scriptArray, treeData, selectedObj) {
    if (scriptArray && scriptArray.length) {
      scriptArray.forEach((obj, index) => {
        if (obj?.folder) {
          setPreselectedValue(obj, treeData, selectedObj);
        } else {
          if (treeData[obj.key] === 'PASS') {
            scriptArray.splice(index, 1);
            if (selectedObj?.suite?.selectedModulesStatus) {
              delete selectedObj?.suite?.selectedModulesStatus[obj.key];
            }
          }
        }
      });
      return scriptArray;
    }
  }

  const getSyncStatusIcon = (syncClasses = '') => {
    return progress === 0 ? (
      <Tooltip title="Sync Status" placement="top">
        <Sync
          fontSize="small"
          className={`mr-3 ${syncClasses}`}
          onClick={() => {
            if (!isSyncDisabled) {
              startCircularProgress();
              setIsSyncDisabled(true);
              getSingleExecutionData();
            }
          }}
        />
      </Tooltip>
    ) : (
      <CircularProgressWithLabel value={progress} />
    );
  };

  return (
    <div>
      {screenMode === 'moduleSpecificPage' ? (
        <div className="content_area_style_noTab_screen overflow-auto" id="journal-scroll">
          <div className="content_area_header_style">
            <label className="main-header-label float-left ">
              {getTruncatedText(executionData?.suite?.name, 40)}
              {executionData?.executionStatus === 'Running' ? (
                <span className="rounded-xl text-xs bg-blue-100 text-blue-700 px-2 py-0.5 ml-3">
                  {executionData?.executionStatus}
                </span>
              ) : executionData?.executionStatus === 'Pending' ? (
                <>
                  <span className={`bg-yellow-400 text-xs rounded-xl text-white px-2 py-0.5 ml-3`}>
                    {getStatusTypeForPending(executionData)}
                  </span>
                  {getStatusTypeForPending(executionData) === 'Queued' && executionDashboardInfo(executionData)}
                </>
              ) : executionData?.executionStatus === 'Terminated' ? (
                <>
                  {executionData?.resultStatus ? (
                    <span
                      className="text-xs rounded-xl bg-red-600 text-white px-2 py-0.5 ml-3"
                      onClick={() => onStatus(executionData)}
                    >
                      {executionData?.executionStatus}
                    </span>
                  ) : (
                    <>
                      <span className="text-xs rounded-xl bg-red-600 text-white px-2 py-0.5 ml-3 opacity-50">
                        {executionData?.executionStatus}
                      </span>{' '}
                      {executionDashboardInfo(executionData)}
                    </>
                  )}
                </>
              ) : executionData?.executionStatus === 'Completed' && executionData?.resultStatus === 'PASS' ? (
                <span
                  className="text-xs rounded-xl bg-green-600 text-white px-2 py-0.5 ml-3 cursor-pointer"
                  onClick={() => onStatus(executionData)}
                >
                  Passed
                </span>
              ) : executionData?.executionStatus === 'Completed' && executionData?.resultStatus === 'FAIL' ? (
                <span
                  className="text-xs rounded-xl bg-red-600 text-white px-2 py-0.5 ml-3 cursor-pointer"
                  onClick={() => onStatus(executionData)}
                >
                  Failed
                </span>
              ) : executionData?.executionStatus === 'Cancelled' ? (
                <span className="text-xs rounded-xl bg-gray-100 text-gray-800 px-2 py-0.5 ml-3">
                  {executionData?.executionStatus}
                </span>
              ) : executionData?.resultStatus === 'WARNING' ? (
                <span
                  className="text-xs rounded-xl warning-status-exe text-white px-2 py-0.5 ml-3 cursor-pointer"
                  onClick={() => onStatus(executionData)}
                >
                  Warning
                </span>
              ) : executionData?.resultStatus === 'Aborted' ? (
                <span
                  className="text-xs rounded-xl bg-red-600 text-white px-2 py-0.5 ml-3 cursor-pointer"
                  onClick={() => onStatus(executionData)}
                >
                  Aborted
                </span>
              ) : executionData?.resultStatus === 'N/A' && executionData?.executionStatus !== 'Terminated' ? (
                <span className="text-xs rounded-xl bg-red-600 text-white px-2 py-0.5 ml-3 cursor-pointer">N/A</span>
              ) : null}
            </label>
            <div className="flex flex-row float-right mt-1">
              {['Running', 'Pending', ...partialResultPageStatuses].includes(executionData?.executionStatus) ? (
                <>
                  {/* <Tooltip title="Search" placement="top">
                                                <SearchOutlined fontSize='small' className="text-gray-500 mr-3 ml-3 cursor-pointer hover:text-blue-700" />
                                            </Tooltip> */}
                  {getSyncStatusIcon()}
                  {!hasUserViewAccessInExecution && (
                    <>
                      <Tooltip title="Terminate" placement="top">
                        <img
                          className="mr-3"
                          src="\assets\execution_logos\terminate.svg"
                          alt="Terminate Execution"
                          onClick={() => {
                            setShowWarningModal(true);
                            setSelectedExeObject(executionData);
                          }}
                        />
                      </Tooltip>
                      <Tooltip title="Run" placement="top">
                        <img
                          className="disable_icon mr-3"
                          src="\assets\execution_logos\execution-run.svg"
                          disabled
                          height="20px"
                          width="20px"
                          alt="Terminate Execution"
                          onClick={() => executeFunction(executionData)}
                        />
                      </Tooltip>
                    </>
                  )}
                </>
              ) : executionData?.executionStatus === 'Terminated' ? (
                <>
                  {/* <Tooltip title="Search" placement="top">
                                                    <SearchOutlined fontSize='small' className="text-gray-500 mr-3 ml-3 cursor-pointer hover:text-blue-700" />
                                                </Tooltip> */}
                  {getSyncStatusIcon()}
                  {!hasUserViewAccessInExecution && (
                    <Tooltip title="Run" placement="top">
                      <img
                        className="mr-3"
                        src="\assets\execution_logos\execution.svg"
                        height="20px"
                        width="20px"
                        alt="Terminate Execution"
                        onClick={() => executeFunction(executionData)}
                      />
                    </Tooltip>
                  )}
                </>
              ) : executionData?.executionStatus === 'Completed' && executionData?.resultStatus === 'PASS' ? (
                <>
                  <Tooltip title="Search" placement="top">
                    <SearchOutlined
                      fontSize="small"
                      className="text-gray-500 mr-3 ml-3 cursor-pointer hover:text-blue-700"
                    />
                  </Tooltip>
                  {getSyncStatusIcon()}
                  {!hasUserViewAccessInExecution && (
                    <Tooltip title="Run" placement="top">
                      <img
                        className="mr-3"
                        src="\assets\execution_logos\execution.svg"
                        height="20px"
                        width="20px"
                        alt="Terminate Execution"
                        onClick={() => executeFunction(executionData)}
                      />
                    </Tooltip>
                  )}
                </>
              ) : executionData?.executionStatus === 'Completed' && executionData?.resultStatus === 'FAIL' ? (
                <>
                  {/* <Tooltip title="Search" placement="top">
                                                            <SearchOutlined fontSize='small' className="text-gray-500 mr-3 ml-3 cursor-pointer hover:text-blue-700" />
                                                        </Tooltip> */}

                  {getSyncStatusIcon()}
                  {!hasUserViewAccessInExecution && (
                    <>
                      <Tooltip title="Run only Failed" placement="top">
                        <img
                          src="\assets\execution_logos\Rerun.svg"
                          className=" cursor-hand mr-3"
                          height="20px"
                          width="20px"
                          onClick={() => reRunFailed(executionData)}
                          alt=""
                        ></img>
                      </Tooltip>
                      <Tooltip title="Run" placement="top">
                        <img
                          className="mr-3"
                          src="\assets\execution_logos\execution.svg"
                          height="20px"
                          width="20px"
                          alt="Terminate Execution"
                          onClick={() => executeFunction(executionData)}
                        />
                      </Tooltip>
                    </>
                  )}
                </>
              ) : (
                (executionData?.resultStatus === 'WARNING' ||
                  executionData?.resultStatus === 'Aborted' ||
                  (executionData?.executionStatus !== 'Terminated' && executionData?.resultStatus === 'N/A')) && (
                  <>
                    {/* <Tooltip title="Search" placement="top">
                                                                <SearchOutlined fontSize='small' className="text-gray-500 mr-3 ml-3 cursor-pointer hover:text-blue-700" />
                                                            </Tooltip> */}

                    {getSyncStatusIcon()}
                    {!hasUserViewAccessInExecution && (
                      <Tooltip title="Run" placement="top">
                        <img
                          className="mr-3"
                          src="\assets\execution_logos\execution.svg"
                          height="20px"
                          width="20px"
                          alt="Terminate Execution"
                          onClick={() => executeFunction(executionData)}
                        />
                      </Tooltip>
                    )}
                  </>
                )
              )}
            </div>
          </div>
          <div className="dashboard_tree_height" id="journal-scroll">
            {tabData?.length ? (
              <Box sx={{ bgcolor: '#f0f3f9', paddingLeft: '9px' }} className="mb-1">
                <Tabs
                  value={value}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="scrollable force tabs example"
                >
                  {exeResponse?.map((obj, index) => (
                    <Tab
                      className="tab-font-style fontPoppinsRegularMd"
                      onClick={() => handleTab(obj?.runId, index)}
                      label={obj?.machine}
                    />
                  ))}
                </Tabs>
              </Box>
            ) : null}

            {renderTree}
          </div>
        </div>
      ) : screenMode === 'rerunFailed' ? (
        <div className="content_area_style overflow-auto" id="journal-scroll">
          <CreateEditSuite
            suiteObj={executionData?.suite}
            rerunMode={true}
            setScreenMode={setScreenMode}
            getAllDashboard={getExecutionData}
          ></CreateEditSuite>
        </div>
      ) : null}
      {showWarningModal && (
        <TerminateWarningComponent
          executionData={selectedExeObject}
          setShowWarningModal={setShowWarningModal}
          terminateExecution={TerminateExecution}
          MyAlert={MyAlert}
          actionKey="Terminate"
        />
      )}
    </div>
  );
};

export default ExecutionSpecificPageParallelExecution;
